/**
 * request
 */
export default [
  (config) => {
    // 需要修改，添加请求header，loading
    return config
  },
  (error) => {
    if (error && error.config) {
      // 需要修改，添加请求错误处理
    }
    return Promise.reject(error)
  }
]
